import { ZipLocation, ZipLocationColor } from 'models';

const SF = ['94', '951', '952', '953', '954', '955'];
const SC = ['956', '957', '958', '959'];
const LA = ['91', '92']; 

export function getZipColor(zip?: string) {
	const lc = getZipLocation(zip);

	switch(lc) {
		case ZipLocation.SC:
			return ZipLocationColor.SC;
		case ZipLocation.LA:
			return ZipLocationColor.LA;
		case ZipLocation.SF:
			return ZipLocationColor.SF;
		default:
			return ZipLocationColor.SF;
	}
}

export function getZipLocation(zip?: string) {
	const zipStr = String(zip);

	if (SC.some((el) => zipStr.startsWith(el))) {
		return ZipLocation.SC;
	}
	if (SF.some((el) => zipStr.startsWith(el))) {
		return ZipLocation.SF;
	}
	if (LA.some((el) => zipStr.startsWith(el))) {
		return ZipLocation.LA;
	}
}